import { translateKey } from 'src/locales/translate';
import WarehouseBadge from '../WarehouseBadge';

const t = (key: string): string => translateKey(`warehouse.demand.table.${key}`);

/** "Z magazynu" or "Spoza magazynu": where a Demand Request's product comes from. */
export default function WarehouseDemandSourceBadge({
  isCatalogueProduct,
}: {
  isCatalogueProduct: boolean;
}): JSX.Element {
  return isCatalogueProduct ? (
    <WarehouseBadge
      label={t('fromCatalogue')}
      hint={t('fromCatalogueHint')}
      color="info"
      icon="mdi:warehouse"
      testId="warehouse-demand-source-catalogue"
    />
  ) : (
    <WarehouseBadge
      label={t('outsideCatalogue')}
      hint={t('outsideCatalogueHint')}
      color="default"
      icon="solar:box-bold"
      testId="warehouse-demand-source-outside"
    />
  );
}
